import { useContext } from 'react';

import './WelcomeElement.scss';

// welcome block before adding your first object
export const WelcomeElement = ({ children, className }) => {
  return (
    <div className={`sb-welcome-element ` + (className ? className : '')}>
      <div className="sb-welcome-element-content">{children}</div>
      <img
        className="sb-welcome-fancy"
        src="/assets/sb-fancy-element.png"
      ></img>
    </div>
  );
};
